import React , { useRef } from 'react'
import { Container } from 'react-bootstrap'
import './../assest/style/Contactus.css'
import emailjs from '@emailjs/browser';
export const Contact = () => {
    const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_vxvqwfd', 'template_ze6odfk', form.current, '2mjirdj1gZcu8h4df')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
  };
  return (
    <div className='contact login'>
        <Container>
            <h3>Contact Me </h3>
        <form ref={form} onSubmit={sendEmail}>
            <div className='forma lele'>
     
      <input type="text" name="user_name"  placeholder='Enter your name'/>   </div> <br/>
      <div className='forma'>
  
      <input type="email" name="user_email"  placeholder='Enter your email'/> 
      </div> 
      <br/>
      <div className='forma'>

      <textarea name="message" placeholder='Enter your message' /> 
      </div>
      <br/>
      <div className='forma'>
      <input type="submit" value="Send" />
      </div>
    </form>
        </Container>
    </div>
  )
}
